"use client";

// import Image from "next/image";
// import { useLiveDataForMatch } from "@/hooks/useLiveData";
// import { useMatchData } from "@/hooks/useMatchData";
import MatchTime from "../KbvMatchTime";
import OtherBetsDropdown from "../OtherBetsDropdown";
import { useState } from "react";
import { useMatches } from "@/hooks/useMatches";
import Loading from "../Loading";
import OddsPill from "../OddsPill";
import TeamRow from "../TeamRow";
import {
  LIVE_STATUSES,
  FINISHED_STATUSES,
  NOT_STARTED_STATUS,
} from "@/contants";
import { formatUnixToVNDate, formatHandicapLabel } from "@/utils/format";
import ICON_ARROW_UP from "@/assets/images/arrow-up.svg";

export default function KiemTienMatch({ match }) {
  // const { getScore } = useLiveDataForMatch(match.id);
  const { getMatchOdds } = useMatches();
  const liveScore = null;
  const [openOtherBets, setOpenOtherBets] = useState(false);
  const [otherOddsData, setOtherOddsData] = useState(null);
  const [loadingOtherOdds, setLoadingOtherOdds] = useState(false);

  // const {
  //   currentHomeScore,
  //   currentAwayScore,
  //   currentHomeHalfScore,
  //   currentAwayHalfScore,
  //   isHomeWin,
  //   isAwayWin,
  //   homeYellow,
  //   homeRed,
  //   awayYellow,
  //   awayRed,
  //   currentHomeCorner,
  //   currentAwayCorner,
  // } = useMatchData(liveScore, match);

  const {
    homeScore: currentHomeScore,
    awayScore: currentAwayScore,
    homeHalfScore: currentHomeHalfScore,
    awayHalfScore: currentAwayHalfScore,
    isHomeWin = false,
    isAwayWin = false,
    homeYellow,
    awayYellow,
    homeRed,
    awayRed,
    homeCorner: currentHomeCorner,
    awayCorner: currentAwayCorner,
  } =  match;

  const statusNum = liveScore?.status !== undefined ? Number(liveScore.status) : Number(match.status);
  const isNotStarted = NOT_STARTED_STATUS.includes(statusNum);
  const isLive = LIVE_STATUSES.includes(statusNum);
  const isFinished = FINISHED_STATUSES.includes(statusNum);

  const handicapOdds = match.handicapOdds?.[0];
  const handicapValue = handicapOdds?.instantHandicap || "";
  const homeHandicapOdds = handicapOdds?.instantHome || "";
  const awayHandicapOdds = handicapOdds?.instantAway || "";

  const overUnderOdds =
    match.overUnderOdds?.[0] || match.odd?.overUnderOdds?.[0];
  const overUnderValue = overUnderOdds?.instantOverUnder || "2.50";
  const overOdds = overUnderOdds?.instantOver || "";
  const underOdds = overUnderOdds?.instantUnder || "";

  const europeOdds = match.europeOdds?.[0];
  const homeEuropeOdds = europeOdds?.instantHome || "";
  const awayEuropeOdds = europeOdds?.instantAway || "";

  const handicapHalfOdds = match.handicapHalfOdds?.[0];
  const handicapHalfValue = handicapHalfOdds?.instantHandicap || "";
  const homeHandicapHalfOdds = handicapHalfOdds?.instantHome || "";
  const awayHandicapHalfOdds = handicapHalfOdds?.instantAway || "";

  const { date: formattedDate, thu: formattedThu, gio: formattedGio } = formatUnixToVNDate(match?.matchTime);

  const handleOtherBetsButtonClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setOpenOtherBets((prev) => !prev);
    if (!openOtherBets && !otherOddsData) {
      setLoadingOtherOdds(true);
      getMatchOdds(match.id, { include: "otherOdd" })
        .then((data) => {
          if (data?.success) setOtherOddsData(data.data);
        })
        .finally(() => setLoadingOtherOdds(false));
    }
  };

  return (
    <div className="relative rounded-lg overflow-hidden bg-[var(--theme-bg)]">
      <div className="flex">
        <div className="w-[45%] shrink-0">
          <table className="w-full table-fixed">
            <colgroup>
              <col className="w-full"/>
            </colgroup>
            <thead>
              <tr className="bg-[var(--theme-accent)]">
                <th className="text-left px-2 py-2.5">
                  {isNotStarted ? (
                    <span className="font-medium text-sm text-left">{`${formattedThu} (${formattedDate}) ${formattedGio}`}</span>
                  ) : (
                    <MatchTime
                      homeCorner={currentHomeCorner}
                      awayCorner={currentAwayCorner}
                      isLive={isLive}
                      isFinished={isFinished}
                      isNotStarted={isNotStarted}
                      matchTime={match.matchTime}
                      liveScore={liveScore}
                      status={statusNum}
                      halfStartTime={match.halfStartTime}
                      textAlignment="left"
                    />
                  )}
                </th>
              </tr>
            </thead>
            <tbody>
              <TeamRow
                name={match.homeName}
                yellow={homeYellow}
                red={homeRed}
                score={currentHomeScore}
                halfScore={currentHomeHalfScore}
                isWin={isHomeWin}
                showScore={isLive || isFinished}
                direction="home"
              />
              <TeamRow
                name={match.awayName}
                yellow={awayYellow}
                red={awayRed}
                score={currentAwayScore}
                halfScore={currentAwayHalfScore}
                isWin={isAwayWin}
                showScore={isLive || isFinished}
                direction="away"
              />              
            </tbody>
          </table>
        </div>
        <div className="flex-1 overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <table className="w-full table-fixed min-w-[400px] border-collapse">
            <colgroup>
              <col className="w-[25%]" />
              <col className="w-[25%]" />
              <col className="w-[25%]" />
              <col className="w-[25%]" />
            </colgroup>
            <thead>
              <tr className="bg-[var(--theme-accent)]">
                <th className="px-2 py-2.5">
                  <span className="text-xs font-medium text-left">Chấp TT</span>
                </th>
                <th className="px-2 py-2.5">
                  <span className="text-xs font-medium text-left">Tài Xỉu TT</span>
                </th>
                <th className="px-2 py-2.5">
                  <span className="text-xs font-medium text-left">1x2 TT</span>
                </th>
                <th className="px-2 py-2.5">
                  <span className="text-xs font-medium text-left">Cược chấp H1</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="px-0.5 py-0.5 align-middle">
                  <OddsPill label={formatHandicapLabel(handicapValue, true)} odds={homeHandicapOdds} />
                </td>
                <td className="px-0.5 py-0.5 align-middle">
                  <OddsPill label={overUnderValue || "2.50"} odds={overOdds} />
                </td>
                <td className="px-0.5 py-0.5 align-middle">
                  <OddsPill label="H" odds={homeEuropeOdds} />
                </td>
                <td className="px-0.5 py-0.5 align-middle">
                  <OddsPill label={formatHandicapLabel(handicapHalfValue, true)} odds={homeHandicapHalfOdds} />
                </td>
              </tr>
              <tr>
                <td className="px-0.5 py-0.5 align-middle">
                  <OddsPill label={formatHandicapLabel(handicapValue, false)} odds={awayHandicapOdds} />
                </td>
                <td className="px-0.5 py-0.5 align-middle">
                  <OddsPill label="U" odds={underOdds} />
                </td>
                <td className="px-0.5 py-0.5 align-middle">
                  <OddsPill label="A" odds={awayEuropeOdds} />
                </td>
                <td className="px-0.5 py-0.5 align-middle">
                  <OddsPill label={formatHandicapLabel(handicapHalfValue, false)} odds={awayHandicapHalfOdds} />
                </td>
              </tr>
              <tr>
                <td colSpan="2" className="px-0 py-2 align-middle">
                  {match.countOtherOdds > 0 && (
                    <div className="flex justify-center items-center gap-1 cursor-pointer" onClick={handleOtherBetsButtonClick}>
                      <span className="text-xs font-medium">{match.countOtherOdds} cược khác</span>
                      <img src={ICON_ARROW_UP} alt="arrow-down" width={16} height={16} className={`transition-transform duration-200 ${openOtherBets ? "rotate-180" : ""}`} />
                    </div>
                  )}
                </td>
                <td className="px-0.5 py-0.5 align-middle">
                  <OddsPill label="D" odds={awayEuropeOdds} />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="px-0 pt-2 align-middle">
        {match.countOtherOdds > 0 && openOtherBets && (
          <>
            {loadingOtherOdds && !otherOddsData && (
              <div className="py-4"><Loading /></div>
            )}
            {!loadingOtherOdds && otherOddsData && (
              <OtherBetsDropdown
                goalOddEvenOdds={otherOddsData?.goalOddEvenOdds}
                correctScoresOdds={otherOddsData?.correctScoresOdds}
                totalCornersOdds={otherOddsData?.totalCornersOdds}
                correctScoresHalfOdds={otherOddsData?.correctScoresHalfOdds}
                totalCornersHalfOdds={otherOddsData?.totalCornersHalfOdds}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
}